import { useQuery, useMutation } from '@tanstack/react-query'
import { Box, Button, Heading, Spinner, Text } from '@n26/nxd'
import { getCockpitDashboard } from '@/features/dashboard/api/cockpitDashboard'
import {
  getManageriumDashboard,
  pingManagerium,
} from '@/features/dashboard/api/managerium'
import { ProfileMenu } from '@/features/auth/ProfileMenu'

export const DashboardPage = () => {
  const { data, isPending, isError } = useQuery({
    queryKey: ['cockpitDashboard'],
    queryFn: getCockpitDashboard,
    enabled: import.meta.env.DEV,
  })

  const manageriumPing = useMutation({ mutationFn: pingManagerium })
  const manageriumDashboard = useMutation({
    mutationFn: () => getManageriumDashboard(593),
  })

  return (
    <Box
      display='flex'
      flexDirection='column'
      justifyContent='center'
      alignItems='center'
      height='full'
      gap='16'
    >
      <Box position='absolute' top='0' right='0' padding='16'>
        <ProfileMenu />
      </Box>

      <Heading level={1}>lionfish is here</Heading>

      <Button
        variant='secondary'
        color='teal'
        loading={manageriumPing.isPending}
        onClick={() => manageriumPing.mutate()}
      >
        Ping managerium
      </Button>
      {manageriumPing.isSuccess && (
        <Text>Managerium says: {manageriumPing.data}</Text>
      )}
      {manageriumPing.isError && (
        <Text color='rhubarb'>Couldn&apos;t reach managerium.</Text>
      )}

      <Button
        variant='secondary'
        color='teal'
        loading={manageriumDashboard.isPending}
        onClick={() => manageriumDashboard.mutate()}
      >
        Fetch managerium dashboard 593 (Okta-protected)
      </Button>
      {manageriumDashboard.isSuccess && (
        <Text>
          Managerium dashboard: {JSON.stringify(manageriumDashboard.data)}
        </Text>
      )}
      {manageriumDashboard.isError && (
        <Text color='rhubarb'>
          {manageriumDashboard.error instanceof Error
            ? manageriumDashboard.error.message
            : 'Failed to fetch managerium dashboard.'}
        </Text>
      )}

      {isPending && <Spinner />}
      {isError && (
        <Text color='rhubarb'>Couldn&apos;t load the cockpit dashboard.</Text>
      )}
      {data && (
        <Text>
          Loaded &quot;{data.name}&quot; (dashboard {data.dashboardId}, instance{' '}
          {data.instance}): {data.cards.length} cards. Last updated{' '}
          {data.lastUpdated ?? 'never'}.
        </Text>
      )}
    </Box>
  )
}
